export const errorMessagesSelector = (state) => {
    return state.errorMessages.records.ids.map(id => {
        return state.errorMessages.records.byId[id];
    });
};

export const errorMessageByIdSelector = (state, id) => {
    return state.errorMessages.records.byId[id];
};

export const errorMessagesCountSelector = (state) => {
    return state.errorMessages.records.totalCount;
};